export interface DangerButtonPalette {
  'danger-button-background-color': string;
}
